import { useEffect, useState } from 'react';

import hooksConstants from 'src/constants/hooks.constants';
import { ClassState } from 'src/interfaces/class.types';
import realtimeService from 'src/services/realtime.service';

export const usePresentation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const callback = (state: ClassState) => {
    const link = state.classLocation?.url ?? state.classLocation?.curriculumUrl;

    if (!link) return;

    const isLinkSecure =
      new URL(link).hostname.split('.').slice(-2).join('.') === 'amplify.com';

    if (isLinkSecure) {
      setIsLoading(true);
      setTimeout(() => {
        window.location.assign(link);
      }, hooksConstants.LESSON_REDIRECT_LOADING_SCREEN_DELAY_MS);
    }
  };

  useEffect(() => {
    if (!realtimeService.hasInitialized) return;

    realtimeService.listenToPresentationStateChange(callback);
    return () =>
      realtimeService.removeListenerForPresentationStateChange(callback);

    // realtimeService.hasInitialized should be listed in deps array for correct subscription
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realtimeService.hasInitialized]);

  return isLoading;
};
